import {createSinglePathSVG} from './TEMPLATE'

export const Loader_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M12 5a7 7 0 0 0-5.218 11.666A1 1 0 0 1 5.292 18a9 9 0 1 1 13.416 0 1 1 0 1 1-1.49-1.334A7 7 0 0 0 12 5Z',
})
